import ls from '@utils/localStorage';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

const productKey = CURRENT_PRODUCT_MODE === 'EI' ? '-' : `-${CURRENT_PRODUCT_MODE.toLowerCase()}-`;

function TabsStorage(keyName) {
  const name = `xalive${productKey}dashboard-tab-ids${keyName}`;

  const storage = ls;
  const isValid = !!storage;

  const initialTabs = { tabsOrder: [], tabsData: {} };
  const set = (tabs = initialTabs) =>
    storage.set({
      key: name,
      value: tabs,
      expires: 1000 * 60 * 60 * 24, // one day
    });

  const get = () => {
    try {
      let tabs = storage.get(name);
      if (typeof tabs !== 'object') {
        tabs = initialTabs;
      }
      return tabs;
    } catch (ex) {
      set();
      return initialTabs;
    }
  };

  const initRefresh = () => {
    if (isValid) {
      const tabs = get();
      if (tabs === null || typeof tabs !== 'object') {
        set();
      }
    }
  };

  const remove = () => {
    storage.remove(name);
  };

  initRefresh();
  return {
    get,
    set,
    isValid,
    remove,
  };
}

export default TabsStorage;
